<template>
  <div class="zui-toast">
    <slot></slot>
  </div>
</template>
<script>
  import '../../assets/less/toast.less'
  export default {}
</script>
